/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit InsurancePaymentAccount/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromPayments from 'Data/payments.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function InsurancePaymentAccount({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/InsurancePaymentAccount"
  
}) {
let paymentAccountValueData = fromData.useDataFormat({ viewPath,
context: 'payment_account',
format: fromPayments.getPayorName,
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 textDecoration="underline dotted"
 className="text-decoration-skip-ink-none text-underline-offset-4"
 data="payment_account"
 format="/Data/payments.js getPayorName"
 text={paymentAccountValueData}
 className="text-decoration-skip-ink-none text-underline-offset-4"
/>
{children}
</React.Fragment>)
}